import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow } from '@ionic/react';
import { Subtitulo, Titulo } from 'app-principal-componentes-visuales';
import { TITULO_PREGUNTA } from '../../../utils/constants';
import React, { useContext, useEffect } from 'react';
import { GA_KEYS, mapGA } from '../../../helpers/GTM';
import { AsistenciaMedicaContext } from '../../../contexts/AsistenciaMedicaContext';
import { TextoComponente } from '../../../interfaces/textoComponente.interface';
import BotonContactanos from './BotonContactanos';
import "./Contactanos.scss";

interface IContactanosProps {
    componente: string,
    deshabilitarModulo?: string,
    texto?: string,
    screen?: string,
    setupData?: any
}

const ContactanosModal = ({ componente, deshabilitarModulo, screen, setupData, texto }: IContactanosProps) => {

    const { isWeb, asistenciaMedica } = useContext(AsistenciaMedicaContext);
    const textoComponente: TextoComponente = asistenciaMedica.textoComponentes.filter((textoComponente) => textoComponente.componente === componente)[0];

    useEffect(() => {
        if (screen && setupData) {
            const configGA = {
                salida_motivo: screen
            }
            mapGA(GA_KEYS.TELEFONOS, setupData, configGA)
        }
    }, [screen])

    let modalStyle = textoComponente.titulo === TITULO_PREGUNTA ? "modal__grid modal__grid-contactanos" : "modal__grid";

    return (
        <IonPage className='asistencia-medica asistencia-contactanos'>
            <IonHeader className='ion-no-border modal__header'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12" className="titulo">
                            <Titulo titulo={textoComponente.titulo} id="titulo-asistencia-medica" />
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>

            <IonContent fullscreen>
                <IonGrid className={modalStyle}>

                    {
                        textoComponente.subtitulo &&
                        <IonRow>
                            <IonCol size='12'>
                                <Subtitulo txt14 titulo={textoComponente.subtitulo} id="subtitulo-sintomas" />
                            </IonCol>
                        </IonRow>
                    }

                    {
                        textoComponente.botones.map((boton) => {
                            if (boton.nombre.includes("riesgo")) {
                                return <BotonContactanos nombre={boton.nombre} texto={boton.texto} phone={false} whatsapp={false} riesgo={true} isWeb={isWeb} deshabilitarModulo={deshabilitarModulo} />
                            } else if (boton.nombre.includes("whatsapp")) {
                                return <BotonContactanos nombre={boton.nombre} texto={boton.texto} textoWsp={texto} phone={false} whatsapp={true} riesgo={false} isWeb={isWeb} deshabilitarModulo={deshabilitarModulo} />
                            } else {
                                return <BotonContactanos nombre={boton.nombre} texto={boton.texto} phone={true} whatsapp={false} riesgo={false} isWeb={isWeb} deshabilitarModulo={deshabilitarModulo} />
                            }
                        })
                    }

                </IonGrid>
            </IonContent>
        </IonPage>
    )
}

export default ContactanosModal